import { createAsyncThunk } from "@reduxjs/toolkit";

export const logoutUser = createAsyncThunk(
  "auth/logout",
  async () => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/app/logout`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      }
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);